import { render, staticRenderFns } from "./PatientData.vue?vue&type=template&id=5ffadb7b&scoped=true&"
import script from "./PatientData.vue?vue&type=script&lang=js&"
export * from "./PatientData.vue?vue&type=script&lang=js&"
import style0 from "./PatientData.vue?vue&type=style&index=0&id=5ffadb7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffadb7b",
  null
  
)

export default component.exports